import { Field } from '@sitecore-jss/sitecore-jss-nextjs';

import { SFCCProductPrice } from '@gn-audio/jss-core';
import { Option } from '@gn-audio/jss-core/common/models';

import { FamilyGroup } from 'api/productCatalogueApi';
import { ISfccProductSearchApiSettings, ISfccSearchRefinement } from 'api/sfccApi/sfccApiTypes';
import { ProductEntityType, ProductFilterModuleMode } from 'common/types/productTypes';
import { SitecoreFieldTypes } from 'common/types/sitecore';
import { PIMProduct } from 'components/common/MagicCards/MagicCards';
import { ComponentProps } from 'lib/component-props';

import { ColorHexMapping } from '../../../api/colorHexMappingApi';

export type AttachedFilter = {
  Title: Field<string>;
  Value: Field<string>;
  Selected: boolean;
};

export type ProductFilterOrder = {
  Title: Field<string>;
  Property: Field<string>;
  Direction: Field<'asc' | 'desc'>;
};

export type ProductFilterGroup = {
  Title: Field<string>;
  AttributeName: Field<string>;
  AttachedFilters: AttachedFilter[];
};

export interface ProductFilterProps {
  searchRefinements: ISfccSearchRefinement[];
  options: ProductFilterModule;
  productFilters: SelectedProductFilters;
  colorHexMappings: ColorHexMapping[];
  setProductFilters: React.Dispatch<React.SetStateAction<SelectedProductFilters>>;
}

export interface SelectedProductFilters {
  SearchText?: string;
  Order?: Option;
  FilterGroups: ProductFilterGroup[];
  PriceRange?: { min: number; max: number };
  SelectedColor: Option[];
}

export interface ProductFilterModuleProps extends ComponentProps {
  fields: SitecoreFieldTypes;
  productCatalogueApi: string;
  colorHexMappings: ColorHexMapping[];
}

export type ProductFilterModule = {
  EntityType: Field<ProductEntityType>;
  NoResultsText: Field<string>;
  SearchPlaceholder: Field<string>;
  NumberOfResultsPerPage: Field<number>;
  OrdersTitle: Field<string>;
  Orders: ProductFilterOrder[];
  FilterGroups: ProductFilterGroup[];
  PreFilterQuery: Field<string>;
  PriceFilterOptionTitle: Field<string>;
  PriceFilterOptionEnabled: Field<boolean>;
  ColorsFilterOptionTitle: Field<string>;
  ColorsFilterOptionEnabled: Field<boolean>;
  Mode: Field<ProductFilterModuleMode>;
};

export interface ISFCCGroupPrice extends SFCCProductPrice {
  brand: string;
  c_pimGroupId: string;
  c_pimFamilyId: string;
  c_productType: string;
}

export type FetchProductDetailsProps = {
  sfccApiSettings: ISfccProductSearchApiSettings;
  sfccSearchQuery: string;
  locale: string;
  productCatalogueApi: string;
};

export type CombinedResults = {
  productCatalogueLabels?: FamilyGroup;
  sfccPricesData?: ISFCCGroupPrice;
  productCatalogueDetails?: PIMProduct;
};

export type Locales = {
  sfccLocale: string;
  productCatalogueLocale: string;
};
